import { type RefObject, useEffect, useRef, useState } from 'react';

export const useCountLines = (): [
  numberOfLines: number,
  targetRef: RefObject<HTMLParagraphElement | null>,
] => {
  const targetRef = useRef<HTMLParagraphElement>(null);
  const [numberOfLines, setNumberOfLines] = useState<number>(0);

  useEffect(() => {
    const countLines = () => {
      if (!targetRef.current) return;

      const { height } = targetRef.current.getBoundingClientRect();

      const lineHeight = parseInt(
        window
          .getComputedStyle(targetRef.current, null)
          .getPropertyValue('line-height'),
      );

      setNumberOfLines(height / lineHeight);
    };

    countLines();
  }, []);

  return [numberOfLines, targetRef];
};
